module.exports = __webpack_public_path__ + "img/printer.9f8de551.svg";